/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useMutation } from 'react-query';
import Button from '../../components/Basic/Button';
import { useLocation } from 'react-router-dom';
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import { CreateDesignReqPayload, CreateDesignAccepted, createNewDesign as createNewDesignReq, createNewDesignRoof } from './api';
import Loader, { Loader_Type } from '../../components/Loader';
import ROUTES from '../../constants/routes';
import { Mapwrap, MapHeader, SetHouseInfoContent, SetHouseBtn } from './styles';
import ZoomControl from './ZoomControl';
import { PARENT_EVENTS, SOlAR_QOUTE_APP_NAME, SUBHUB_APP_NAME, TOOL_RENDER_MODE } from '../../constants';
import { TOOL_ERROR_CODES } from 'constants/toolError';
import { postToolError } from 'parentEvents';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from 'store';
import { removeFalsyValueFromObj, convertObjValsToNum } from '../../util';
import { setQueryParamState } from 'store/slices/QueryParamsSlice';
import { designCreateAccepted, resetDesignCreate } from 'store/slices/DesignCreateSlice';
import { useOrgTheme } from 'contexts/ThemeContext';
import useNavigateWithQueryParams from 'hooks/useNavigateWithQueryParams';
import { markCreateDesignStart, resetDesignPipelineTiming } from 'utils/designLoadTiming';

const containerStyle = { width: '100%', height: '100%' };

const MARKER_PX = 72;

const makeMarkerSvg = (stroke = 'black', fill = 'white') => `
	<svg xmlns="http://www.w3.org/2000/svg" width="91" height="91" viewBox="0 0 91 91" fill="none">
		<path d="M88 43.2441C89.2426 43.2441 90.25 44.2515 90.25 45.4941C90.25 46.7368 89.2426 47.7441 88 47.7441H58C56.7574 47.7441 55.75 46.7368 55.75 45.4941C55.75 44.2515 56.7574 43.2441 58 43.2441H88Z" fill="${fill}" stroke="${stroke}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M33 43.2441C34.2426 43.2441 35.25 44.2515 35.25 45.4941C35.25 46.7368 34.2426 47.7441 33 47.7441H3C1.75736 47.7441 0.75 46.7368 0.75 45.4941C0.75 44.2515 1.75736 43.2441 3 43.2441H33Z" fill="${fill}" stroke="${stroke}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M47.7578 88C47.7578 89.2426 46.7505 90.25 45.5078 90.25C44.2652 90.25 43.2578 89.2426 43.2578 88L43.2578 58C43.2578 56.7574 44.2652 55.75 45.5078 55.75C46.7505 55.75 47.7578 56.7574 47.7578 58L47.7578 88Z" fill="${fill}" stroke="${stroke}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M47.7578 33C47.7578 34.2426 46.7505 35.25 45.5078 35.25C44.2652 35.25 43.2578 34.2426 43.2578 33L43.2578 3C43.2578 1.75736 44.2652 0.75 45.5078 0.75C46.7505 0.75 47.7578 1.75736 47.7578 3L47.7578 33Z" fill="${fill}" stroke="${stroke}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M66 22.7441C67.2426 22.7441 68.25 23.7515 68.25 24.9941V34.9941C68.25 36.2368 67.2426 37.2441 66 37.2441C64.7574 37.2441 63.75 36.2368 63.75 34.9941V27.2441H56C54.7574 27.2441 53.75 26.2368 53.75 24.9941C53.75 23.7515 54.7574 22.7441 56 22.7441H66Z" fill="white" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M66 67.7441C67.2426 67.7441 68.25 66.7368 68.25 65.4941V55.4941C68.25 54.2515 67.2426 53.2441 66 53.2441C64.7574 53.2441 63.75 54.2515 63.75 55.4941V63.2441H56C54.7574 63.2441 53.75 64.2515 53.75 65.4941C53.75 66.7368 54.7574 67.7441 56 67.7441H66Z" fill="white" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M24 22.7441C22.7574 22.7441 21.75 23.7515 21.75 24.9941V34.9941C21.75 36.2368 22.7574 37.2441 24 37.2441C25.2426 37.2441 26.25 36.2368 26.25 34.9941V27.2441H34C35.2426 27.2441 36.25 26.2368 36.25 24.9941C36.25 23.7515 35.2426 22.7441 34 22.7441H24Z" fill="white" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M24 67.7441C22.7574 67.7441 21.75 66.7368 21.75 65.4941V55.4941C21.75 54.2515 22.7574 53.2441 24 53.2441C25.2426 53.2441 26.25 54.2515 26.25 55.4941V63.2441H34C35.2426 63.2441 36.25 64.2515 36.25 65.4941C36.25 66.7368 35.2426 67.7441 34 67.7441H24Z" fill="white" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M45 40.7441C47.6234 40.7441 49.75 42.8708 49.75 45.4941C49.75 48.1175 47.6234 50.2441 45 50.2441C42.3766 50.2441 40.25 48.1175 40.25 45.4941C40.25 42.8708 42.3766 40.7441 45 40.7441Z" fill="${fill}" stroke="${stroke}" stroke-width="1.5"/>
	</svg>`;

function LocationMap() {
	const { navigateWithQueryParams } = useNavigateWithQueryParams();
	const data: any = useLocation();
	const { isLoaded } = useJsApiLoader({
		id: 'google-map-script',
		googleMapsApiKey: process.env.REACT_APP_GOOGLE_STATIC_MAP_KEY as string,
	});

	// do NOT access window.google at render time
	const mapRef = useRef<google.maps.Map | null>(null);
	// the same map for ZoomControl, which needs a re-render once it exists (set on load / unmount only)
	const [map, setMap] = useState<google.maps.Map | null>(null);
	const center = data?.state?.coordinates ?? { lat: 0, lng: 0 };

	const queryParams = useSelector((state: RootState) => state.QueryParams.data);
	const dispatch = useDispatch<AppDispatch>();
	const { selectHouseText, runAiBtnText, mainHeading } = useOrgTheme();

	const reqToCreateRoofDesign = ['roof', 'roofwithsolar'].includes(queryParams.toolType);
	const iframeIsEmbeddedInSubhub = queryParams.parentAppName === SUBHUB_APP_NAME;

	const isDarkMode = queryParams.displayMode === 'dark';

	// options without touching window.google
	// backgroundColor is what shows before the satellite tiles arrive (Google's default is light grey);
	// colorScheme themes Google's own UI. Google reads both only when the map is created.
	// The zoom buttons are ours (ZoomControl), in the theme's colours.
	const mapOptions = useMemo(() => ({
		mapTypeId: 'hybrid' as google.maps.MapTypeId,
		disableDefaultUI: true,
		zoomControl: false,
		clickableIcons: false,
		gestureHandling: 'greedy',
		tilt: 0,
		backgroundColor: isDarkMode ? '#1f1f1f' : undefined,
		colorScheme: isDarkMode ? 'DARK' : 'LIGHT',
	}), [isDarkMode]);

	const pinDataUrl = useMemo(() => {
		const svg = makeMarkerSvg();
		return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
	}, []);

	// energy inputs bridge
	useEffect(() => {
		function changeBillInputs(event: MessageEvent) {
			if (event.data?.eventType !== PARENT_EVENTS.ENERGY_INPUTS_CHANGED || !iframeIsEmbeddedInSubhub) return;
			const electricInputChanges = convertObjValsToNum(removeFalsyValueFromObj(event.data?.values));
			const { billAmount, annualUsage: energy } = electricInputChanges;
			if (!billAmount && !energy) return;
			dispatch(setQueryParamState({ ...queryParams, billAmount, annualEnergy: energy }));
		}
		window.addEventListener('message', changeBillInputs);
		return () => window.removeEventListener('message', changeBillInputs);
	}, [dispatch, iframeIsEmbeddedInSubhub, queryParams]);

	const onLoad = (map: google.maps.Map) => {
		mapRef.current = map;
		setMap(map);
		const myWindow: any = window;
		const bounds = new myWindow.google.maps.LatLngBounds(
			data.state?.coordinates
		);
		map.fitBounds(bounds);
		window.parent.postMessage({ id: PARENT_EVENTS.SET_HOUSE_MAP_LOADED }, '*');
	};

	const onUnmount = () => {
		console.log('unload');
		mapRef.current = null;
		setMap(null);
	};

	const {
		billAmount, externalId, panelKey, parentAppName,
		gutterSetback, nonGutterSetback, obstructionSetback,
		eavesSetback, rakesSetback,
		ridgesSetback, valleysSetback, hipsSetback,
		toolRenderMode
	} = queryParams;
	const isAutoSaveMode = toolRenderMode === TOOL_RENDER_MODE.BACKGROUND;

	// Async-create status is owned by the store (designCreateListener): PENDING/PROCESSING keep the
	// loader up, READY triggers navigation, FAILED clears back to the map.
	const createStatus = useSelector((state: RootState) => state.designCreate.data.status);

	const designMutation = useMutation(
		async ({ latLngStr }: { latLngStr: string }): Promise<CreateDesignAccepted | undefined> => {
			if (!latLngStr) throw new Error('Map not ready');
			// starts the create → design fetch → shading-complete wall-clock timer (dev observability).
			// Auto-save mode sends deferShadingAnalysis: false below, so shading runs inside create and
			// no analysis follows the fetch — that run is timed up to the roof-data fetch only.
			markCreateDesignStart({ expectShadingRunInBg: !isAutoSaveMode });
			if (reqToCreateRoofDesign) {
				return createNewDesignRoof(latLngStr, { externalID: externalId });
			}
			const payload: CreateDesignReqPayload = {
				panelKey,
				externalID: externalId,
				billAmount: +billAmount!,
				setbacks:{
					eaves:eavesSetback ?? gutterSetback,
					rakes:rakesSetback ?? gutterSetback,
					ridges:ridgesSetback ?? nonGutterSetback,
					valleys:valleysSetback ?? nonGutterSetback,
					hips:hipsSetback ?? nonGutterSetback,
					gutters:gutterSetback,
					obstructions:obstructionSetback
				}
			};

			if(isAutoSaveMode){
				payload.deferShadingAnalysis = false;
			}
			return createNewDesignReq(latLngStr, payload);
		},
		{
			// POST is now 202 Accepted (no design payload). Hand the tracking id to the store-owned
			// designCreateListener, which polls the build (create-status), refetches on READY, and
			// drives navigation via slice status. See src/store/middleware/designCreateListener.ts.
			onSuccess: (accepted) => {
				if (!accepted?.designUUID) {
					postToolError(TOOL_ERROR_CODES.CREATE_DESIGN_FAILED, new Error('Design creation failed. Please try again.'));
					return;
				}
				dispatch(designCreateAccepted({
					designUUID: accepted.designUUID,
					designType: reqToCreateRoofDesign ? 'ROOF' : 'SOLAR',
					panelKey,
				}));
			},
			onError: async (error) => {
				resetDesignPipelineTiming(); // sequence never happened — don't leave the timer armed
				window.parent.postMessage({ id: 'SOLARQUOTEEMBED_UNSUPPORTED_ADDRESS' }, '*');
				postToolError(TOOL_ERROR_CODES.CREATE_DESIGN_FAILED, error);
			},
		}
	);

	// Terminal transitions from the create watch: READY → navigate into the editor; FAILED → reset
	// back to the map (the middleware already surfaced the errorCode to the parent).
	useEffect(() => {
		if (createStatus === 'READY') {
			navigateWithQueryParams(ROUTES.SHOW_DATA);
			dispatch(resetDesignCreate());
		} else if (createStatus === 'FAILED') {
			dispatch(resetDesignCreate());
		}
	}, [createStatus, dispatch, navigateWithQueryParams]);

	const handleSetHouseClick = () => {
		const latLngStr = mapRef.current?.getCenter()?.toUrlValue();
		if (!latLngStr) {
			console.log('Map not ready');
			postToolError(TOOL_ERROR_CODES.CREATE_DESIGN_FAILED, new Error('Map is still loading. Please try again in a moment.'));
			return;
		}
		window.parent.postMessage({ id: PARENT_EVENTS.SET_HOUSE_CLICKED }, '*');

		designMutation.mutate({ latLngStr });
	};

	// loader while the POST is in flight AND while the queued build is still running
	if (designMutation.isLoading || createStatus === 'PENDING' || createStatus === 'PROCESSING') {
		const type = (parentAppName === SOlAR_QOUTE_APP_NAME && !reqToCreateRoofDesign)
			? Loader_Type.SLIDER
			: Loader_Type.INDEFINITE;
		return <Loader type={type} designType={reqToCreateRoofDesign ? 'ROOF' : 'SOLAR'} />;
	}

	// IMPORTANT: don't render GoogleMap until loader finished
	if (!isLoaded) return <></>;

	return (
		<Mapwrap>
			<MapHeader>
				{!!mainHeading && (
					<div className='left'>
						<h3 className='title'>{mainHeading}</h3>
					</div>
				)}
			</MapHeader>

			<SetHouseInfoContent>
				<span className='info'>{selectHouseText}</span>
			</SetHouseInfoContent>

			<SetHouseBtn>
				<Button onClick={handleSetHouseClick} className='run-ai-btn'>
					{runAiBtnText}
					<svg xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="none">
						<path d="M1.5 6H16M16 6L11.5 10.5M16 6L11.5 1.5" stroke="#07174D" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
					</svg>
				</Button>
			</SetHouseBtn>

			{/* Map + center pin overlay (no React state on pan) */}
			<div style={{ position: 'relative', width: '100%', height: '100%' }}>
				<GoogleMap
					mapContainerStyle={containerStyle}
					center={center}
					zoom={20}
					options={mapOptions}
					onLoad={onLoad}
					onUnmount={onUnmount}
				/>
				{/* Center pin as a lightweight overlay */}
				<div
					aria-hidden
					style={{
						pointerEvents: 'none',
						position: 'absolute',
						left: '50%',
						top: '50%',
						transform: 'translate(-50%, -50%)',
						width: MARKER_PX,
						height: MARKER_PX,
						backgroundImage: `url(${pinDataUrl})`,
						backgroundSize: 'contain',
						backgroundRepeat: 'no-repeat',
					}}
				/>
				<ZoomControl map={map} />
			</div>
		</Mapwrap>
	);
}

export default React.memo(LocationMap);
